<%# Clear the form after sending %>
<%= turbo_stream.replace "new_message" do %>
  <%= form_with model: Message.new, class: "space-y-4" do |form| %>
    <div class="flex gap-4">
      <div class="w-1/4">
        <%= form.text_field :username,
            placeholder: "Your name",
            value: cookies[:chat_username],
            class: "w-full border rounded p-2" %>
      </div>
      <div class="flex-1">
        <%= form.text_field :body,
            placeholder: "Type a message...",
            autofocus: true,
            class: "w-full border rounded p-2" %>
      </div>
      <%= form.submit "Send",
          class: "bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700" %>
    </div>
  <% end %>
<% end %>
